import React, { PropTypes } from 'react';
import classNames from 'classnames';
import {
    Card,
        H1,
        H3,
        Body,
        SectionHeading
} from '@chartbeat/light-side/lib/components';
import { CATEGORY_CLASSES, MEDIUM_CLASSES } from '../../utils/category-utils';

import styles from './story-item.cssm';


const StoryItem = ({
    rank,
    title,
    publisher,
    authors,
    categories,
    medium,
    url,
    image,
    //fade,
    highlightMedium
}) => {

    const renderAuthorsIfNeeded = () => {
        if (!authors) {
            return null;
        }

        // lists of exactly two authors get a fancy shmancy ampersand
        const authorJoin = (authors.length === 2) ? ' & ' : ', ';
        return <Body className={styles.byline}>
                    {`by ${authors.join(authorJoin)}`}
               </Body>;
    }

    const renderCategoryBordersIfNeeded = () => {
        if (categories) {
            return (
                <div className={styles.borderContainer}>
                    {categories.map((category) => {
                        return <div
                            key={category}
                            className={styles[`${category}Border`]}
                        />
                    })}
                </div>
            )
        }
    }

    const containerClass = classNames(
        styles.container,
        {[styles[`${categories[0]}Container`]]: !!categories},
        //{[styles.fade]: fade}
    );

    return (
        <a href={url} target="_blank">
        <Card className={containerClass}>
            { medium !== undefined &&
                <div className={classNames(
                    styles[`${medium}Logo`],
                    highlightMedium ? styles.highlight : null
                )}/>
            }
            { image !== undefined && <img src={image} className={styles.storySparkline}/>}
            <H1 className={styles.rank}>{rank}</H1>
            {renderCategoryBordersIfNeeded()}

            <div className={styles.metadataBody}>
                <SectionHeading className={styles.publisher}>{publisher}</SectionHeading>
                <H3 serif={true} className={styles.title}>{title}</H3>
                {renderAuthorsIfNeeded()}
            </div>
        </Card>
        </a>
    );
}

StoryItem.propTypes = {
    rank: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    publisher: PropTypes.string,
    authors: PropTypes.array,
    categories: PropTypes.arrayOf(PropTypes.oneOf(CATEGORY_CLASSES)),
    medium: PropTypes.oneOf(MEDIUM_CLASSES),
    url: PropTypes.string,
    image: PropTypes.node,
    //fade: PropTypes.bool
}

export default StoryItem;



// WEBPACK FOOTER //
// ./src/components/story-item/story-item.js